export default "__VITE_ASSET__CL9HMkbK__"